// extracted by mini-css-extract-plugin
module.exports = {"sticky":"MyReports_sticky__3Leny","myReports":"MyReports_myReports__3k0_O","reports":"MyReports_reports__3LADO","moreReportsSpinner":"MyReports_moreReportsSpinner__2xAV2"};